(function(){
    angular
        .module('maApp.validation')
        .directive('pbDateMonthDayBeforeAfter', pbDateMonthDayBeforeAfter);

    pbDateMonthDayBeforeAfter.$inject = [];

    function pbDateMonthDayBeforeAfter(){
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {

                ctrl.$validators.pbDateMonthDayBeforeAfter = pbDateMonthDayBeforeAfterValidator;

                function pbDateMonthDayBeforeAfterValidator(modelValue) {
                    var startmonth = scope.$eval('vm.newPrescriptionAction.startmonth');
                    var startday = scope.$eval('vm.newPrescriptionAction.startday');
                    var endmonth = scope.$eval('vm.newPrescriptionAction.endmonth');
                    var endday = scope.$eval('vm.newPrescriptionAction.endday');

                    //pull values that have not been set yet, based on the control that is being validated
                    if('pbIsMonthBefore' in attrs){
                        startmonth = modelValue;
                    }
                    if('pbIsDayBefore' in attrs){
                        startday = modelValue;
                    }
                    if('pbIsMonthAfter' in attrs){
                        endmonth = modelValue;
                    }
                    if('pbIsDayAfter' in attrs){
                        endday = modelValue;
                    }

                    var startdate = Date.create(Date.create().getFullYear(), parseInt(startmonth)-1, parseInt(startday));
                    var enddate = Date.create(Date.create().getFullYear(), parseInt(endmonth)-1, parseInt(endday));

                    var isValid = null;
                    var allDatesAvailable = Boolean( startmonth && startday && endmonth && endday );
                    if(allDatesAvailable){
                        isValid = startdate.isBefore(enddate) || startdate.is(enddate);
                    } else {
                        isValid = true;    //can't validate without all fields
                    }

                    return isValid;

                }
            }
        };
    }
})();